import { apiSlice } from '../../store/apiSlice';
import { store } from '../../store/store';
import { shouldTrackEvents } from './shouldTrackEvents';
import { getVisitId } from './getVisitId';

export const trackOnceEvents = ['site_load', 'checkout_visit', 'checkout_start'];

export const trackCustomEvent = (eventName, eventData = {}, ref = null) => {
  const isBot = /bot|crawl|spider|slurp|facebook|fetch|preview|whatsapp/i.test(navigator.userAgent);
  if (isBot || navigator.webdriver || !shouldTrackEvents()) return;

  const session_id = getVisitId();
  const platform = /iPhone|iPad|iPod|Mac/.test(navigator.userAgent)
    ? 'iOS'
    : /Android/.test(navigator.userAgent)
    ? 'Android'
    : 'Web';

  if (trackOnceEvents.includes(eventName)) {
    const key = `session_tracked_${eventName}`;
    const alreadyTracked = localStorage.getItem(key) === 'true';
    if (alreadyTracked) return;
    localStorage.setItem(key, 'true');
  }

  const payload = {
    event_name: eventName,
    event_data: {
      ...eventData,
      ...(ref ? { ref } : {}),
      platform,
    },
    session_id,
  };

  store.dispatch(apiSlice.endpoints.trackEvent.initiate(payload));
};

export const resetVisitSession = () => {
  localStorage.removeItem('visit_session');
  trackOnceEvents.forEach(event => {
    localStorage.setItem(`session_tracked_${event}`, 'false');
  });
};
